import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams, generatePath } from "react-router-dom";
import "./Doorscanner";
import logo from "../assets/img/fireLogo.png";
import { loginUser } from "../store/slices/UserSlice";
// import DoorScanner from "../doorscanner";
import { clearUser } from "../store/slices/UserSlice";
import http from "../api/server";

import Toaster from "./common/Toaster";
import { useRef } from "react";
const LogIn = () => {
  const [step, setStep] = useState("login"); // checkEmail | resetPassword | login
  // const [strength, setStrength] = useState("");
  // const [strengthColor, setStrengthColor] = useState("black");
  const [userEmail, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [inputError, setInputError] = useState("");
  const inputRefs = useRef([]);
  const defaultOTPObj = {
    digit1: "",
    digit2: "",
    digit3: "",
    digit4: "",
    digit5: "",
    digit6: "",
  };
  useEffect(() => {
    inputRefs.current[0]?.focus(); // Focus on the first input on component mount
  }, []);
  const [otpValues, setOtpValues] = useState(defaultOTPObj);
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const [counter, setCounter] = useState(30);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  // dispatch and navigate
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { clientName } = useParams();

  useEffect(() => {
    dispatch(clearUser());
  }, [dispatch]);

  useEffect(() => {
    let timer;
    if (isResendDisabled && step == "enter otp" && counter > 0) {
      timer = setInterval(() => {
        setCounter((prev) => prev - 1);
      }, 1000);
    } else if (counter === 0) {
      setIsResendDisabled(false);
      clearInterval(timer);
    }
    return () => clearInterval(timer);
  }, [counter, isResendDisabled, step]);

  const handleResend = () => {
    // Trigger resend OTP logic here
    console.log("Resending OTP...");
    setCounter(40);
    setIsResendDisabled(true);
    sendOTP();
    setOtpValues(defaultOTPObj);
  };

  // Simulated API call for password reset
  // Real API call for password reset
  const resetPasswordAPI = async (email) => {
    try {
      const response = await http.get(
        "/api/Auth/AnonymousUser-OTP?userEmail=" + email
      );
      return response;
    } catch (error) {
      return error;
    }
  };

  // const verifyOTP = async () => {
  //   const otpString = Object.values(otpValues).join("");
  //   try {
  //     const response = await http.post("api/Auth/validate-otp", {
  //       email,
  //       otp: otpString
  //     });
  //     return response;
  //   } catch (error) {
  //     return error;
  //   }
  // };

  //
  // BookingForm.jsx
  useEffect(() => {
    console.log("BookingForm mounted");
  }, []);

  // NotFound.jsx
  useEffect(() => {
    console.log("NotFound mounted");
  }, []);
  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setLoginError("");
    const otpString = Object.values(otpValues).join("");
    dispatch(loginUser({ userEmail, otp: otpString })).then((response) => {
      if (
        response?.error?.message ||
        response?.error?.message == "Invalid OTP." ||
        response?.error?.message == "OTP is expired. Please re-generate OTP." ||
        response?.error?.message ==
          "OTP is already used. Please re-generate OTP."
      ) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: response?.error?.message,
        });
        setOtpValues(defaultOTPObj);
        setLoginError(response?.error?.message);
        console.log(loginError);
        setStep("login");
        setEmail("");
      } else {
        resetValue();
        // if (response?.payload?.data) {
        //   navigate("/booking");
        // }
        if (response?.payload?.data) {
          if (clientName) {
            navigate(
              generatePath("/client/:clientName/booking", { clientName })
            );
          } else {
            // If this login ran on "/" or "/client" (no :clientName in URL),
            // route somewhere sensible (e.g., generic client chooser/login).
            navigate("/client");
          }
        }
      }
    });

    setLoading(false);
  };

  const isValidEmailOrMobile = (value) => {
    // Email regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // General mobile regex: optional +, 8-15 digits
    const mobileRegex = /^\+?\d{8,15}$/;
    return emailRegex.test(value) || mobileRegex.test(value);
  };

  const sendOTP = async () => {
    if (!isValidEmailOrMobile(userEmail)) {
      setInputError(
        "Please enter a valid email or mobile number (8-15 digits, optional '+')."
      );
      return;
    }
    const response = await resetPasswordAPI(userEmail, password);
    if (response.status !== 400) {
      setStep("enter otp");
    } else {
      setLoginError(response?.response?.data?.message);
    }
  };

  const [validate, setValidate] = useState({
    hasLow: false,
    hasCap: false,
    hasNumber: false,
    has8digit: false,
  });
  const strengthNew = Object.values(validate).reduce((a, item) => a + item, 0);

  const feedback = {
    1: "Password is to weak!",
    2: "It's still weak! ",
    3: "You almost there!",
    4: "Great!! now your password is strong",
  }[strengthNew];

  useEffect(() => {
    if (!password && !confirmPassword) return;
  }, [password, confirmPassword, feedback]);

  const resetValue = () => {
    setConfirmPassword("");
    setLoading(false);
    setPassword("");
    setLoginError("");
    setValidate({
      hasLow: false,
      hasCap: false,
      hasNumber: false,
      has8digit: false,
    });
    setOtpValues(defaultOTPObj);
  };

  const setOTPValue = (value, digitKey, index) => {
    setOtpValues((prevOtpValues) => ({
      ...prevOtpValues,
      [digitKey]: value.substring(value.length - 1), // Take only the last character entered
    }));
    // Auto-focus the next input field if a digit is entered and it's not the last field
    if (value.length === 1 && index !== 5) {
      inputRefs.current[index + 1].focus();
    }
  };
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
    setOtpValues(defaultOTPObj);
  };
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && index > 0 && e.target.value === "") {
      inputRefs.current[index - 1]?.focus();
    } else if (e.key === "ArrowRight" && index < length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();

    if (pastedData.length === 6 && /^\d+$/.test(pastedData)) {
      const optArray = pastedData.split("");

      const defaultOTPObj = {
        digit1: optArray[0],
        digit2: optArray[1],
        digit3: optArray[2],
        digit4: optArray[3],
        digit5: optArray[4],
        digit6: optArray[5],
      };

      setOtpValues(defaultOTPObj);
      // Optionally focus the last input after pasting
      inputRefs.current[5]?.focus();
    }
  };

  const handleEmail = (e) => {
    setLoginError("");
    setEmail(e.target.value);
    setInputError("");
  };
  return (
    <div className="main_body">
      <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={() => {
          closeButton();
        }}
      />
      {step === "enter otp" && (
        <>
          <div className="containers d-flex align-item-center py-2 main_header justify-content-center login_card">
            <div className="card col-12 col-sm-9 col-lg-5 mt-5">
              <div className="d-flex align-items-center justify-content-start mt-3 mb-2">
                <img src={logo} className="login-page-logo" alt="logo" />
              </div>
              <div className="card-body  px-5 py-3">
                <div className="col-sm-12">
                  <p className="fs-3 fw-semibold">Verify OTP</p>
                </div>
                <div className="col-sm-12">
                  <p className="mes">
                    Enter the 6-digit code sent to<br></br>
                    <strong
                      style={{
                        marginLeft: "5px",
                        color: "#FFA500",
                        fontSize: "12px",
                      }}
                    >
                      {userEmail}
                    </strong>
                  </p>
                </div>
                <div className="form-floating my-4 justify-content-center d-flex gap-3">
                  <input
                    type="text"
                    className="form-control-box1"
                    maxLength="1"
                    value={otpValues.digit1}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit1", 0);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 0)}
                    ref={(el) => (inputRefs.current[0] = el)}
                    onPaste={handlePaste}
                  />
                  <input
                    type="text"
                    className="form-control-box2"
                    maxLength="1"
                    value={otpValues.digit2}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit2", 1);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 1)}
                    ref={(el) => (inputRefs.current[1] = el)}
                  />
                  <input
                    type="text"
                    className="form-control-box3"
                    maxLength="1"
                    value={otpValues.digit3}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit3", 2);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 2)}
                    ref={(el) => (inputRefs.current[2] = el)}
                  />
                  <input
                    type="text"
                    className="form-control-box4"
                    maxLength="1"
                    value={otpValues.digit4}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit4", 3);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 3)}
                    ref={(el) => (inputRefs.current[3] = el)}
                  />
                  <input
                    type="text"
                    className="form-control-box5"
                    maxLength="1"
                    value={otpValues.digit5}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit5", 4);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 4)}
                    ref={(el) => (inputRefs.current[4] = el)}
                  />
                  <input
                    type="text"
                    className="form-control-box6"
                    maxLength="1"
                    value={otpValues.digit6}
                    onChange={(e) => {
                      setOTPValue(e.target.value, "digit6", 5);
                    }}
                    onKeyDown={(e) => handleKeyDown(e, 5)}
                    ref={(el) => (inputRefs.current[5] = el)}
                  />
                </div>
                <div className="col-sm-12">
                  <p>
                    <span
                      onClick={isResendDisabled ? null : handleResend}
                      className="resend"
                      style={{
                        cursor: isResendDisabled ? "not-allowed" : "pointer",
                      }}
                    >
                      {isResendDisabled
                        ? `Resend OTP in ${counter}s`
                        : "Resend OTP"}
                    </span>
                  </p>
                </div>
                <div className="row my-3">
                  <div className="col-12 d-flex justify-content-center">
                    <button
                      type="submit"
                      className="btn btn-secondary mb-3 w-100"
                      onClick={(e) => handleVerifyOTP(e)}
                    >
                      {loading ? "Please Wait..." : "Verify OTP"}
                    </button>
                  </div>
                </div>
                <div className="col-12 d-flex justify-content-center">
                  <button
                    type="submit"
                    className="btnresend mb-3 w-100"
                    onClick={() => {
                      setStep("login");
                      resetValue();
                    }}
                  >
                    <i className="fa fa-solid fa-arrow-left"></i> Back to login
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {step === "login" && (
        <div className="containers d-flex align-item-center py-2 main_header justify-content-center login_card">
          <div className="card login-card col-12 col-sm-8 col-lg-4  mt-5 pt-5">
            <div className="text-center mt-3 mb-2">
              <img src={logo} className="login-page-logo" alt="logo" />
              <h6 className="mb-2 fw-bold white-text">Welcome to</h6>
              <h4 className="mb-0 fw-bold white-text">
                Booking Management <br></br>System
              </h4>
              <p className="text">Enter your email address to continue</p>
            </div>
            <div className="card-body mx-auto py-0">
              <div className="form-floating my-2">
                <input
                  type="text"
                  className="form-controlinputbox"
                  id="floatingInput"
                  onChange={(e) => handleEmail(e)}
                  placeholder="Enter your email address"
                />
                {/* <label htmlFor="floatingInput">Email Address</label> */}
              </div>
              {inputError && (
                <div
                  style={{
                    color: "red",
                    marginTop: "-15px",
                    marginBottom: "10px",
                    fontSize: "0.95em",
                  }}
                >
                  {inputError}
                </div>
              )}
              <div className="col-sm-12 mb-3">
                <button
                  type="submit"
                  className="btn btn-orange mb-3 w-100"
                  disabled={!userEmail}
                  onClick={() => {
                    sendOTP();
                    setOtpValues(defaultOTPObj);
                  }}
                >
                  Send OTP
                </button>
              </div>
              {/* <div className="col-sm-12 mb-4 text-center">
                <a href="getHelp.html">Get help signing in</a>
              </div> */}
              <p className="footertext mx-auto">
                By continuing, you agree to our Terms of Service and Privacy
                Policy
              </p>
            </div>
          </div>
        </div>
      )}

      {/* <DoorScanner/> */}
      <div className="footer-fixed mt-4">
        <p className="footertextdown">Powered By</p>
        <img
          src={require("../assets/img/Assure Fire Final Logo-04.png")}
          alt="Acache Logo"
          className="bottom-right-logo"
        />
      </div>
    </div>
  );
};

export default LogIn;
